
import moment from "moment";

import { SiderealTime, Body, SearchRiseSet, SearchAltitude, Equator, Horizon, Illumination } from 'astronomy-engine';



/*
  Devuelve True si la hora actual
  es entre las 7h y 19h

  La webcam Allsky diurna de CIAI solo funciona en esas horas
*/
export function isDayTime() {
  const ahora = moment.utc();
  const hora = ahora.hour();
  
  return hora >= 7 && hora < 19;
}

export function d2hms(d, delimiter = ":") {
    const h = d / 15;
    const hh = Math.floor(h);
    const m = (h - hh) * 60;
    const mm = Math.floor(m);
    const s = (m - mm) * 60;
    const ss = s.toFixed(3);
    
    const h0 = hh < 10 ? "0" : "";
    const m0 = mm < 10 ? "0" : "";
    const s0 = ss < 10 ? "0" : "";
  
    return h0 + hh + delimiter + m0 + mm + delimiter + s0 + ss;
}

export function h2hm(h) {
    const hh = Math.floor(h);
    const m = (h - hh) * 60;
    const mm = Math.floor(m);
    
    const h0 = hh < 10 ? "0" : "";
    const m0 = mm < 10 ? "0" : "";
  
    return /* h0 + */ hh + "h " + m0 + mm + "m";
}
  

export function d2dms(d, delimiter = ":") {
    let sign = "";

    if (d < 0) {
      d = Math.abs(d);
      sign = '-';
    } else {
      sign = '+';
    }
  
    const dd = Math.floor(d);
    const m = (d - dd) * 60;
    const mm = Math.floor(m);
    const s = (m - mm) * 60;
    const ss = s.toFixed(3);
  
    const d0 = dd < 10 ? "0" : "";
    const m0 = mm < 10 ? "0" : "";
    const s0 = ss < 10 ? "0" : "";
  
    return sign + d0 + dd + delimiter + m0 + mm + delimiter + s0 + ss;
}

/**
 * Convierte un valor de tiempo en formato 'HH:MM:SS.S' (horas, minutos, segundos)
 * a grados decimales. Se usa comúnmente para la Ascensión Recta (RA).
 * 
 * Grados decimales=(H+60M​+3600S​)×15
 * 
 * @param {string} hms - La coordenada de tiempo en formato string (e.g., "12:34:56.7").
 * @returns {number} La coordenada en grados decimales.
 */
export function hms2d(hms) {
    if (!hms || typeof hms !== 'string') {
        throw new Error("Input must be a non-empty string in 'HH:MM:SS.S' format.");
    }

    const parts = hms.split(':').map(part => parseFloat(part));

    if (parts.length !== 3 || parts.some(isNaN)) {
        throw new Error("Invalid format. Use 'HH:MM:SS.S'.");
    }

    const [hours, minutes, seconds] = parts;

    // Conversión de horas a grados: (H + M/60 + S/3600) * 15
    const degrees = (hours + (minutes / 60) + (seconds / 3600)) * 15;

    return degrees;
}


/**
 * Convierte un valor angular en formato 'DD:MM:SS.S' (grados, minutos, segundos)
 * a grados decimales. Se usa comúnmente para la Declinación (Dec).
 * 
 * Grados decimales=±(G+60M​+3600S​)
 * 
 * @param {string} dms - La coordenada angular en formato string (e.g., "-30:15:45.2" o "30:15:45.2").
 * @returns {number} La coordenada en grados decimales.
 */
export function dms2d(dms) {
    if (!dms || typeof dms !== 'string') {
        throw new Error("Input must be a non-empty string in 'DD:MM:SS.S' format.");
    }

    // Determinar el signo antes de dividir la cadena
    const sign = dms.trim().startsWith('-') ? -1 : 1;
    // Eliminar el signo para evitar errores en parseFloat de los minutos/segundos
    const cleanDms = dms.startsWith('-') || dms.startsWith('+') ? dms.substring(1) : dms;

    const parts = cleanDms.split(':').map(part => parseFloat(part));

    if (parts.length !== 3 || parts.some(isNaN)) {
        throw new Error("Invalid format. Use 'DD:MM:SS.S'.");
    }

    const [degrees, minutes, seconds] = parts;

    // Conversión: G + M/60 + S/3600. Se aplica el signo al resultado final.
    // Usamos Math.abs(degrees) en la suma por si el signo estaba solo en el primer componente.
    const decimalDegrees = (Math.abs(degrees) + (minutes / 60) + (seconds / 3600)) * sign;

    return decimalDegrees;
}

export function deg2date(degrees, date) {

    let datetime = moment(date).set({hour:0,minute:0,second:0,millisecond:0}).add(degrees/15, 'hours');

    return datetime;
}

/**
 * name solver using Simbad server
 * 
 * http://vizier.cfa.harvard.edu/viz-bin/nph-sesame/A?
 * http://cdsweb.u-strasbg.fr/cgi-bin/nph-sesame/A?
 * 
 * http://cds.unistra.fr/cgi-bin/nph-sesame/-oxp/NSV?
 * 
 * 
 */
export async function sesame(name) {
//export function sesame(name) {

    try {
        let sesame_url = encodeURI("https://cds.unistra.fr/cgi-bin/nph-sesame/-oxp/~A?" + name); 
 
        const response = await fetch(sesame_url);
        const xmlText = await response.text();

        const parser = new DOMParser(); // ¡nativo del navegador!
        const xmlDoc = parser.parseFromString(xmlText, 'text/xml');

        const jradeg = xmlDoc.getElementsByTagName("jradeg")[0].childNodes[0].nodeValue
        const jdedeg = xmlDoc.getElementsByTagName("jdedeg")[0].childNodes[0].nodeValue 

        var data = {'ra': d2hms(parseFloat(jradeg)), 'dec': d2dms(parseFloat(jdedeg))};
 
    } catch (error) {
        var data = false;
    }

    return data;
}


/**
 * Tiempo Sidereo Local (LST)
 * 
 * Tiempo Sidereo Local (LST) = GST + (Longitud Este / 15° por hora)
 * 
 * @param {Date} date: UTC datetime
 * @param {float} longitude: Negative if West (degrees)
 * 
 * @returns {moment}: Local sidereal time in moment object
 */
export function LocalSiderealTime(date, longitude) {

    // Calcula el Tiempo Sidéreo de Greenwich (GST) en grados decimales
    // Greenwich Apparent Sidereal Time (GAST).
    // https://github.com/cosinekitty/astronomy/tree/master/source/js#siderealtimedate--number
    // return GAST in hours
    const gstDegrees = SiderealTime(date) * 15;

    // Convierto la longitud de grados a horas
    const longitudeHours = longitude / 15;

    // Calculo el Tiempo Sidéreo Local (LST) en horas decimales
    let lstHoursDecimal = (gstDegrees / 15 + longitudeHours) % 24;
    if (lstHoursDecimal < 0) {
        lstHoursDecimal += 24;
    }

    // Extraigo horas, minutos y segundos de las horas decimales
    const lstHours = Math.floor(lstHoursDecimal);
    const lstMinutesDecimal = (lstHoursDecimal - lstHours) * 60;
    const lstMinutes = Math.floor(lstMinutesDecimal);
    const lstSecondsDecimal = (lstMinutesDecimal - lstMinutes) * 60;
    const lstSeconds = Math.round(lstSecondsDecimal);

    // Creo un objeto Moment representando la hora UTC de $date con los valores calculados
    const lstMoment = moment.utc().startOf('day')
        .add(lstHours, 'hours')
        .add(lstMinutes, 'minutes')
        .add(lstSeconds, 'seconds');

    return lstMoment;
}

/**
 * Formateo de fecha datetime a formato YYYY-MM-DD HH:mm:ss
 * 
 * @param {Date} date 
 * @returns {string} Datetime in string format
 */
export function FormatDate(date) {
    var year = Pad(date.getFullYear(), 4);
    var month = Pad(1 + date.getMonth(), 2);
    var day = Pad(date.getDate(), 2);
    var hour = Pad(date.getHours(), 2);
    var minute = Pad(date.getMinutes(), 2);
    var second = Pad(date.getSeconds(), 2);
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export function Pad(s, w) {
    s = s.toFixed(0);
    while (s.length < w) {
        s = '0' + s;
    }
    return s;
}


/**
 * Convierte el numero de días desde J2000.0 a UT1
 * 
 * @param {float} daysFraction 
 * @returns {Date} Date object in UTC 
 */
export function j2000ToUTC(daysFraction) {
    // La fecha J2000.0 en UT es 1 de enero de 2000 a las 11:58:55.816 UTC
    const j2000UT = new Date(Date.UTC(2000, 0, 1, 11, 58, 55, 816));

    // Convertir los días fraccionarios a milisegundos
    const millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000
    const millisecondsFromJ2000 = daysFraction * millisecondsPerDay;

    // Calcular la nueva fecha y hora
    const resultDate = new Date(j2000UT.getTime() + millisecondsFromJ2000);

    return resultDate;
}


/**
 * 
 * Sun information: sunrise, sunset, civil twilight, nautical twilight, astronomical twilight
 * 
 * @see AstroTime https://github.com/cosinekitty/astronomy/tree/master/source/js#astrotime
 * 
 * Universal Time (UT1/UTC) in fractional days since the J2000 epoch. Universal Time represents
 * time measured with respect to the Earth's rotation, tracking mean solar days. 
 * The Astronomy library approximates UT1 and UTC as being the same thing. 
 * 
 * Las fechas devueltas en días desde J2000 se pueden convertir a Date usando la función j2000ToUTC.
 * 
 * @param {Array} observer 
 * @param {Date} obsdate 
 * @returns {Array} {AstroTime} 
 */
export function sunInfo(observer, obsdate) {

    // searchRiseSet(body: Body, observer: Observer, direction: Direction, startTime: Time, limitDays: Double, metersAboveGround: Double = 0.0): Time?
    let sunrise = SearchRiseSet('Sun', observer, +1, obsdate, -1);
    let sunset = SearchRiseSet('Sun', observer, -1, obsdate, +1);

    // Civil twilight
    // SearchAltitude(body, observer, direction, dateStart, limitDays, altitude) ⇒ AstroTime
    // https://github.com/cosinekitty/astronomy/tree/master/source/js#SearchAltitude
    let civil_twilight_dusk = SearchAltitude('Sun', observer, -1, obsdate, +1, -6);
    let civil_twilight_down  = SearchAltitude('Sun',  observer, +1, obsdate, -1, -6);

    // Nautical twilight
    let nautical_twilight_dusk = SearchAltitude('Sun',  observer, -1, obsdate, +1, -12);
    let nautical_twilight_down = SearchAltitude('Sun',  observer, +1, obsdate, -1, -12);

    // Astronomical twilight
    let astronomical_twilight_dusk = SearchAltitude('Sun',  observer, -1, obsdate, +1, -18);
    let astronomical_twilight_down = SearchAltitude('Sun',  observer, +1, obsdate, -1, -18);

    return {
        'sunrise': moment(sunrise.date).utc(),
        'sunset': moment(sunset.date).utc(),
        'civil_twilight_dusk': moment(j2000ToUTC(civil_twilight_dusk.ut)),
        'civil_twilight_down': moment(j2000ToUTC(civil_twilight_down.ut)),
        'nautical_twilight_dusk': moment(j2000ToUTC(nautical_twilight_dusk.ut)),
        'nautical_twilight_down': moment(j2000ToUTC(nautical_twilight_down.ut)),
        'astronomical_twilight_dusk': moment(j2000ToUTC(astronomical_twilight_dusk.ut)),
        'astronomical_twilight_down': moment(j2000ToUTC(astronomical_twilight_down.ut))
    };
}

/**
 * 
 * @param {Observer} observer 
 * @param {Date} obsdate in UT
 * @returns {Array[Moment, Moment, Array[float, float, float]]} {moonrise, moonset, moonphase, illumination}
 * 
 * 
 * 
 * El parametro illumination devuelve un objeto con la siguiente estructura:
 *  { mag, phase_angle, helio_dist }
 */
export function moonInfo(observer, obsdate) {

    /* 
        (alias) SearchRiseSet(body: Body, observer: Observer, direction: number, dateStart: FlexibleDateTime,
    *                       limitDays: number, metersAboveGround?: number): AstroTime | null
    
    *   @brief
    *   Searches for the next time a celestial body rises or sets as seen by an observer on the Earth.
    *
    *  This function finds the next rise or set time of the Sun, Moon, or planet other than the Earth. Rise time is when the body first starts to be *  visible above the horizon. For example, sunrise is the moment that the top of the Sun first appears to peek above the horizon. Set time is the * 
    *  moment when the body appears to vanish below the horizon. Therefore, this function adjusts for the apparent angular radius of the observed body * (significant only for the Sun and Moon).

    *  This function corrects for a typical value of atmospheric refraction, which causes celestial bodies to appear higher above the horizon than * they would if the Earth had no atmosphere. Astronomy Engine uses a correction of 34 arcminutes. Real-world refraction varies based on air temperature, pressure, and humidity; such weather-based conditions are outside the scope of Astronomy Engine.

        Note that rise or set may not occur in every 24 hour period. For example, near the Earth's poles, there are long periods of time where the Sun stays below the horizon, never rising. Also, it is possible for the Moon to rise just before midnight but not set during the subsequent 24-hour day. This is because the Moon sets nearly an hour later each day due to orbiting the Earth a significant amount during each rotation of the Earth. Therefore callers must not assume that the function will always succeed.

        @param body
        The Sun, Moon, any planet other than the Earth, or a user-defined star that was created by a call to DefineStar.

        @param observer — Specifies the geographic coordinates and elevation above sea level of the observer.

        @param direction
        Either +1 to find rise time or -1 to find set time. Any other value will cause an exception to be thrown.

        @param dateStart — The date and time after which the specified rise or set time is to be found.

        @param limitDays
        Limits how many days to search for a rise or set time, and defines the direction in time to search. When limitDays is positive, the search is performed into the future, after dateStart. When negative, the search is performed into the past, before dateStart. To limit a rise or set time to the same day, you can use a value of 1 day. In cases where you want to find the next rise or set time no matter how far in the future (for example, for an observer near the south pole), you can pass in a larger value like 365.

        @param metersAboveGround
        Defaults to 0.0 if omitted. Usually the observer is located at ground level. Then this parameter should be zero. But if the observer is significantly higher than ground level, for example in an airplane, this parameter should be a positive number indicating how far above the ground the observer is. An exception occurs if metersAboveGround is negative.

        @returns
        The date and time of the rise or set event, or null if no such event occurs within the specified time window.
    */
                                // body, observer, direction, dateStart, limitDays, metersAboveGround
                                // limitDays = +-2 para que busque en dos días 
    let moonrise = SearchRiseSet('Moon', observer, +1, obsdate, +2); 
    let moonset  = SearchRiseSet('Moon', observer, -1, obsdate, +2);

    let equ_ofdate = Equator('Moon', obsdate, observer, true, true);
    let hor = Horizon(obsdate, observer, equ_ofdate.ra, equ_ofdate.dec, 'normal')

    /*
    moment() compare:
        isSame
        isAfter
        isSameOrAfter
        isSameOrBefore

    Indico fechas en UTC para comparar. La luna puede salir o no ese día en hora local, 
    pero no hacerlo en UTC.
    */
    let moonrise_moment = moment(moonrise.date);
    let moonset_moment = moment(moonset.date);
    return {
        'moonrise': moonrise_moment.utc(),
        'moonrise_today':  moonrise_moment.utc().isSame(obsdate, 'day'),
        'moonset': moonset_moment.utc(),
        'moonset_today': moonset_moment.utc().isSame(obsdate, 'day'),

        //'moonphase': MoonPhase(obsdate),
        'illumination': Illumination(Body.Moon, obsdate),
        'altitude': hor.altitude,
        'azimuth': hor.azimuth,
        'set_before_rise': moonset_moment > moonrise_moment
    };
}


/**
 * Restructura los datos de meteo para graficarlos
 * Los convierte en una "multi-serie" de highcharts
 * 
 * @param {Array} data 
 * @param {Array} stations 
 * @param {Array} sensors 
 * @returns {Array} series
 */
export function data2series(data, stations, sensors) {

  let series = {};

  sensors.forEach(function(sensor, sensor_idx) {
    series[sensor] = stations.map((station, index) => ({
      name: station,
      data: data[station]?.historyData[sensor] || [],
      color: ['#007bff', '#28a745', '#ffc107', '#fd7e14', '#e83e8c', '#6c757d', '#17a2b8'][index],
      marker: {
        enabled: false  // hide line markers
      }
    }));
  });

  return series

}


export function getTargets() {
    let targets = localStorage.getItem('targets');

    if (targets) {
        const targets_list = JSON.parse(targets);
        
        return targets_list;
    }
   
    return [];
}

export function displayTargetsTable() {
  // Leer datos del localStorage
  const targetsJSON = localStorage.getItem('targets');
  
  // Verificar si existen datos
  if (!targetsJSON) {
    console.log('No hay datos en localStorage');
    return;
  }
  
  // Parsear el JSON
  const targets = JSON.parse(targetsJSON);
  
  // Verificar si el array está vacío
  if (targets.length === 0) {
    console.log('El array de targets está vacío');
    return;
  }
  
  // Crear la tabla
  let tableHTML = `
    <table border="1" style="border-collapse: collapse; width: 100%;">
      <thead>
        <tr>
          <th style="padding: 8px; text-align: left;">Name</th>
          <th style="padding: 8px; text-align: left;">RA</th>
          <th style="padding: 8px; text-align: left;">Dec</th>
        </tr>
      </thead>
      <tbody>
  `;
  
  // Agregar filas para cada target
  targets.forEach(target => {
    tableHTML += `
      <tr>
        <td style="padding: 8px;">${target.name}</td>
        <td style="padding: 8px;">${target.ra}</td>
        <td style="padding: 8px;">${target.dec}</td>
      </tr>
    `;
  });
  
  tableHTML += `
      </tbody>
    </table>
  `;
  
  // Insertar la tabla en el DOM (asumiendo que hay un div con id="tableContainer")
  document.getElementById('tableContainer').innerHTML = tableHTML;
  
  return tableHTML;
}

export function addTarget() {

    let name = document.getElementById('target_name').value;
    let ra = document.getElementById('target_ra').value;
    let dec = document.getElementById('target_dec').value;

    //let coords = hex2d(ra, dec);
    let coords = [ra, dec];
    var target = {
            "name": name,
            "ra": coords['ra'],
            "dec": coords['dec'],
        };

    var targets = JSON.parse(localStorage.getItem("targets"));
    if (targets == null) targets = [];

    localStorage.setItem("target", JSON.stringify(target));

    // Save targets back to local storage
    targets.push(target);
    localStorage.setItem("targets", JSON.stringify(targets));
}




